import { render, staticRenderFns } from "./about-me.vue?vue&type=template&id=2e99b214&"
import script from "./about-me.ts?vue&type=script&lang=ts&"
export * from "./about-me.ts?vue&type=script&lang=ts&"
import style0 from "./about-me.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports